import React from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { TaskActivity } from '../../../../types/TaskActivity';
import { COMMENT_TIMESTAMP_FORMAT, formatRelativeTime } from '../../../../common/dateUtils';
import { getUserProfilePictureUrl } from '../../../../common/userHelper';
import colorTokens from '../../../../constants/design_system/colors';
import CustomTooltip from '../../../../components/UI/Tooltip/CustomTooltip';
import { renderActivityContent } from './activityRenderer';

interface ActivityLogEntryProps {
  activity: TaskActivity;
}

export const ActivityLogEntry: React.FC<ActivityLogEntryProps> = ({ activity }) => {
  const { user } = activity;
  const actorName = user.fullName || user.email;

  return (
    <div className="flex flex-wrap items-center gap-x-1 gap-y-1 text-xs leading-4 text-brand-grey-dark">
      <Avatar
        icon={<UserOutlined />}
        size={16}
        className="shrink-0"
        style={{ backgroundColor: colorTokens.neutral[400], fontSize: 9 }}
        src={getUserProfilePictureUrl(user.profilePicturePath)}
      >
        {actorName?.trim()?.[0]?.toUpperCase()}
      </Avatar>
      <span className="font-semibold text-neutral-900">{actorName}</span>
      {renderActivityContent(activity)}
      <CustomTooltip title={dayjs(activity.createdAt).format(COMMENT_TIMESTAMP_FORMAT)}>
        <span className="ml-2 font-semibold text-neutral-900 cursor-default">
          {formatRelativeTime(activity.createdAt)}
        </span>
      </CustomTooltip>
    </div>
  );
};
